/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfo_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"freeShippingHelpers_item" | "PdpSharedCustomsMessage_item">;
    readonly " $refType": "PdpSharedShippingInfo_item";
};
export type PdpSharedShippingInfo_item$data = PdpSharedShippingInfo_item;
export type PdpSharedShippingInfo_item$key = {
    readonly " $data"?: PdpSharedShippingInfo_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfo_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "freeShippingHelpers_item",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "vertical",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "shipmentQuotes",
          "storageKey": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isComplimentary",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "totalAmount",
              "storageKey": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "serviceMethod",
              "storageKey": null,
              "args": null,
              "concreteType": "ShipmentServiceMethod",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "region",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Region",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "regionName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedCustomsMessage_item",
      "args": null
    }
  ]
};
(node as any).hash = 'ca2c0c9ab0c52a8c1d475ecbd33337ba';
export default node;
